import React, { useState, useEffect } from 'react';
import { inventoryAPI } from '../../services/api';
import toast from 'react-hot-toast';

export default function LowStock() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    inventoryAPI.lowStock()
      .then(r => setItems(r.data))
      .catch(() => toast.error('Failed to load'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div className="page-header"><div><h1>Low Stock Alert</h1><p className="subtitle">{items.length} products below reorder level</p></div></div>
      <div className="card">
        <div className="table-container">
          {loading ? <div className="loading-container"><div className="spinner" /></div> : (
            <table>
              <thead><tr><th>Product</th><th>SKU</th><th style={{textAlign:'right'}}>Current Stock</th><th style={{textAlign:'right'}}>Available</th><th style={{textAlign:'right'}}>Reorder Level</th><th style={{textAlign:'right'}}>Min Order Qty</th><th>Status</th></tr></thead>
              <tbody>
                {items.map(p => (
                  <tr key={p.id}>
                    <td><div style={{fontWeight:600}}>{p.name}</div>{p.generic_name && <div className="text-xs text-secondary">{p.generic_name}</div>}</td>
                    <td className="td-mono">{p.sku}</td>
                    <td className="td-amount font-bold" style={{color:'var(--danger)'}}>{p.total_stock}</td>
                    <td className="td-amount">{p.available_stock}</td>
                    <td className="td-amount">{p.reorder_level}</td>
                    <td className="td-amount">{p.min_order_qty}</td>
                    <td>{Number(p.total_stock) === 0 ? <span className="badge badge-red">Out of Stock</span> : <span className="badge badge-orange">Low</span>}</td>
                  </tr>
                ))}
                {items.length === 0 && <tr><td colSpan={7} className="text-center text-secondary" style={{padding:40}}>All products are well-stocked!</td></tr>}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
